import NProgress from "nprogress";

export default function() {
    (function($) {
        // lazy load images in image heavy sections (like multimedia page)
        $(".mg-lazy-images img[data-src]").each(function(item) {
            const src = $(this).data("src");
            if (src) {
                this.src = src;
                $(this).removeClass("hidden");
            }
        });

        NProgress.start();
        $(".mg-lazy-images").imagesLoaded(function() {
            NProgress.done();
        });
    })(jQuery);
}



// WEBPACK FOOTER //
// ./src/js/partials/lazy-images.js